import { Event as GlobalEvent } from "../../../../../../Global/Base/Events";
import { ValidationErrorType } from "../../../../../../OW.Remoting/Basic/EOWExceptionsInterfaces";
import { Localization } from "../../../../../../OW.Remoting/Remoting/Localization";
import { Control } from "../../../../../UI.BaseControls/Control";
import { IValidatable, IValidationResult } from "../../../../../UI.BaseControls/ControlInterfaces";
import { createElement, registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";

export class TimeAgeCombo extends Control implements IValidatable {
    private _combo: HTMLSelectElement;

    public set value(v: any) {
        switch (v) {
            case "quarter":
                this._combo.selectedIndex = 1;
                break;
            case "year":
                this._combo.selectedIndex = 2;
                break;
            case "month":
                this._combo.selectedIndex = 3;
                break;
            case "week":
                this._combo.selectedIndex = 4;
                break;
            case "day":
                this._combo.selectedIndex = 5;
                break;
        }
    }

    public get value(): any {
        return this._combo.value;
    }

    protected override _constructor(): void {
        super._constructor();

        this._combo = createElement({ type: "select" }) as HTMLSelectElement;
        this._combo.innerHTML = "";

        this.disposeOnDetach = false;

        this.appendChild(this._combo);

        this._combo.appendChild(createElement({
            type: "option",
            html: "-", // vyberte
            attrs: { value: "" },
        }));

        let element: HTMLElement;

        this._combo.appendChild(element = createElement({ type: "option", attrs: { value: "quarter" } }));
        Localization.addLocTxtData(element, "GUI-603263"), // čtvrtletích

        this._combo.appendChild(element = createElement({ type: "option", attrs: { value: "year" } }));
        Localization.addLocTxtData(element, "GUI-603257"), // letech

        this._combo.appendChild(element = createElement({ type: "option", attrs: { value: "month" } }));
        Localization.addLocTxtData(element, "GUI-603258"), // měsících

        this._combo.appendChild(element = createElement({ type: "option", attrs: { value: "week" } }));
        Localization.addLocTxtData(element, "GUI-603259"), // týdnech

        this._combo.appendChild(element = createElement({ type: "option", attrs: { value: "day" } }));
        Localization.addLocTxtData(element, "GUI-603260"); // dnech

        this._eventsController.addListener(this._combo, "click", (event: MouseEvent) => {
            event.stopImmediatePropagation(); // zamezení nechtěného zavření celého filtračního okna po kliknutí na položku comboboxu
        });
    }

    private _localizationsForInThisOption: Map<string, string> =
        new Map([
            ["quarter", "GUI-603264"], // čtvrtletí
            ["year", "GUI-603265"], // roce
            ["month", "GUI-603266"], // měsíci
            ["week", "GUI-603267"], // týdnu
            ["day", "GUI-603268"], // dnu
        ]);

    public setLocalizationsForInThisOption(): void {
        for (const option of this._combo.options) {
            Localization.addLocTxtData(option, this._localizationsForInThisOption.get(option.value));
        }
    }

    public isValid: boolean = true;
    public validityChanged = new GlobalEvent<IValidatable, IValidationResult>();
    public isInRequiredInvalidState: boolean = false;
    public readonly currentValidity: IValidationResult = null;

    public validate(): boolean {
        return this._combo.selectedIndex > 0;
    }

    public setValid(): void {
        throw new Error("Not implemented");
    }

    public setInvalid(_locKey: string, _message?: string, _errorType?: ValidationErrorType): void {
        throw new Error("Not implemented");
    }
}

registerCustomElement("tsc-TimeAgeCombo", TimeAgeCombo);
